const products = [
    {
        id: 1,
        productName: 'iPhone 13 Pro',
        productImageURL: '/assets/iphone13pro.png',
        productCategory: 'Mobile Phones',
        productPrice: '1099',
        productRating: '4'
    },
    {
        id: 2,
        productName: 'Samsung Galaxy S21',
        productImageURL: '/assets/galaxys21.png',
        productCategory: 'Mobile Phones',
        productPrice: '899',
        productRating: '4.5'
    },
    {
        id: 3,
        productName: 'Leather Jacket',
        productImageURL: '/assets/leather_jacket.png',
        productCategory: 'Jackets',
        productPrice: '149',
        productRating: '3.5'
    },
    {
        id: 4,
        productName: 'Faux Fur Coat',
        productImageURL: '/assets/faux_fur_coat.png',
        productCategory: 'Jackets',
        productPrice: '99',
        productRating: '4'
    },
    {
        id: 5,
        productName: 'Leather Wallet',
        productImageURL: '/assets/leather_wallet.png',
        productCategory: 'Wallets',
        productPrice: '29',
        productRating: '3'
    },
    {
        id: 6,
        productName: 'Smartwatch',
        productImageURL: '/assets/smartwatch.png',
        productCategory: 'Watches',
        productPrice: '199',
        productRating: '3'
    },
    {
        id: 7,
        productName: 'Sony Headphones',
        productImageURL: "/assets/sony_headphones.png",
        productCategory: 'Electronics',
        productPrice: '249',
        productRating: '3.5'
    },
    {
        id: 8,
        productName: 'Dell Inspiron Laptop',
        productImageURL: '/assets/dell_inspiron.png',
        productCategory: 'Electronics',
        productPrice: '899',
        productRating: '4'
    },
    {
        id: 9,
        productName: 'Nike Air Max',
        productImageURL: '/assets/nike_air_max.png',
        productCategory: 'Shoes',
        productPrice: '129',
        productRating: '3.5'
    },
    {
        id: 10,
        productName: 'Adidas Ultraboost',
        productImageURL: '/assets/adidas_shoes.png',
        productCategory: 'Shoes',
        productPrice: '149',
        productRating: '4.5'
    },
    {
        id: 11,
        productName: 'Cotton T-Shirt',
        productImageURL: '/assets/cotton_tshirt.png',
        productCategory: 'Clothing',
        productPrice: '19',
        productRating: '2'
    },
    {
        id: 12,
        productName: 'Denim Jeans',
        productImageURL: '/assets/denim_jeans.png',
        productCategory: 'Clothing',
        productPrice: '39',
        productRating: '2.5'
    },
    {
        id: 13,
        productName: 'Swiss Army Knife',
        productImageURL: '/assets/swiss_knife.png',
        productCategory: 'Tools',
        productPrice: '49',
        productRating: '1.5'
    },
    {
        id: 14,
        productName: 'LED Desk Lamp',
        productImageURL: '/assets/desk_lamp.png',
        productCategory: 'Home & Office',
        productPrice: '29',
        productRating: '2'
    },
    {
        id: 15,
        productName: 'Water Bottle',
        productImageURL: '/assets/stainless_steel_water_bottle.png',
        productCategory: 'Kitchen',
        productPrice: '15',
        productRating: '3'
    },
    {
        id: 16,
        productName: 'Cookware Set',
        productImageURL: '/assets/cookware_set.png',
        productCategory: 'Kitchen',
        productPrice: '89',
        productRating: '3'
    },
    {
        id: 17,
        productName: 'Yoga Mat',
        productImageURL: '/assets/yoga_mat.png',
        productCategory: 'Sports & Fitness',
        productPrice: '25',
        productRating: '3.5'
    },
    {
        id: 18,
        productName: 'Resistance Bands Set',
        productImageURL: '/assets/resistance_bands_set.png',
        productCategory: 'Sports & Fitness',
        productPrice: '19',
        productRating: '3.5'
    },
    {
        id: 19,
        productName: 'Artificial Plant Decor',
        productImageURL: '/assets/artificial_plants.png',
        productCategory: 'Home Decor',
        productPrice: '39',
        productRating: '4'
    },
    {
        id: 20,
        productName: 'Bluetooth Speaker',
        productImageURL: '/assets/bt_speaker.png',
        productCategory: 'Electronics',
        productPrice: '59',
        productRating: '3.5'
    }
];
  
export default products;
  